__turbopack_context__.v({
  "ambient": "login-module__WEZH7G__ambient",
  "backToLogin": "login-module__WEZH7G__backToLogin",
  "brandMark": "login-module__WEZH7G__brandMark",
  "card": "login-module__WEZH7G__card",
  "copyCodes": "login-module__WEZH7G__copyCodes",
  "core": "login-module__WEZH7G__core",
  "error": "login-module__WEZH7G__error",
  "eyebrow": "login-module__WEZH7G__eyebrow",
  "footer": "login-module__WEZH7G__footer",
  "form": "login-module__WEZH7G__form",
  "grid": "login-module__WEZH7G__grid",
  "intro": "login-module__WEZH7G__intro",
  "orbit": "login-module__WEZH7G__orbit",
  "otpInput": "login-module__WEZH7G__otpInput",
  "passwordField": "login-module__WEZH7G__passwordField",
  "passwordLabel": "login-module__WEZH7G__passwordLabel",
  "qrImage": "login-module__WEZH7G__qrImage",
  "qrLoading": "login-module__WEZH7G__qrLoading",
  "qrSetup": "login-module__WEZH7G__qrSetup",
  "recoveryCodes": "login-module__WEZH7G__recoveryCodes",
  "reveal": "login-module__WEZH7G__reveal",
  "savedCheck": "login-module__WEZH7G__savedCheck",
  "screen": "login-module__WEZH7G__screen",
  "secretKey": "login-module__WEZH7G__secretKey",
  "secure": "login-module__WEZH7G__secure",
  "setupCard": "login-module__WEZH7G__setupCard",
  "signal": "login-module__WEZH7G__signal",
  "submit": "login-module__WEZH7G__submit",
});
